// extracted by mini-css-extract-plugin
module.exports = {"sideMenu":"_2CbAY-","opened":"_26KtEm","header":"_8CUmd7","closeIcon":"_1SdTzw","content":"_15rDu6","instagram":"eWjS64","join":"_2e-nAo","section":"_38qDrV"};